import {
  addCopy,
  classifyArray,
  getDistinct,
  getSameAttribute,
  sortArray
} from '@/utils/handleData.js'
import { daysFormat, monthFormat } from '@/filters'
import { getBar } from '@/utils/getChartOption.js'
export default {
  namespaced: true,
  state: {
    centerline: {}, // 路线坐标
    constructionRoad: {}, // 施工便道坐标
    resident: {}, // 机构驻地及场站
    structure: {}, // 主要构造物
    legend: {},
    coreIndicators: {},
    leftAnalysis: {},
    rightAnalysis: {},
    hasAnimation: {}
  },
  getters: {},
  mutations: {
    setResident(state, params = {}) {
      var resident = JSON.parse(JSON.stringify(state.resident))
      resident[params.key] = params.value
      state.resident = resident
    },
    setStructure(state, params = {}) {
      var structure = JSON.parse(JSON.stringify(state.structure))
      structure[params.key] = params.value
      state.structure = structure
    },
    setAnalysisData(state, params = {}) {
      var newData = JSON.parse(JSON.stringify(state[params.key]))
      if (params.layer && params.value) {
        // 更新图层内key对应全部模块或类型数据
        newData[params.layer] = params.value
      } else if (params.layer && params.fields) {
        // 更新图层内key对应任一或多个模块或类型数据
        if (!newData[params.layer]) {
          newData[params.layer] = {}
        }
        for (const field in params.fields) {
          newData[params.layer][field] = params.fields[field]
        }
      }
      state[params.key] = newData
    }
  },
  actions: {
    // 获取机构下属组织机构
    async getOrgStation({ rootState, commit, dispatch }, uid) {
      await dispatch('bidSection/getSubBidSection', uid, { root: true })
      var orgStation = []
      var latSum = 0
      var lngSum = 0
      var center = []
      var project = JSON.parse(
        JSON.stringify(rootState.bidSection.subBidSection)
      )
      project.forEach((item) => {
        item.position = item.xLng && item.yLat ? [item.xLng, item.yLat] : null
        item.uid = item.orgUid
        item.iconfont =
          item.vType === 'simPro' ? 'icon-company-fill' : 'icon-gongsi'
        item.iconColor = 'red'
        item.contentType = 'circle'
        item.contentColor = '#fd0e024a'
        item.label = {
          content:
            item.vType === 'simPro' ? item.orgCode : item.orgCode.slice(0, 4)
        }
        lngSum += item.xLng ? item.xLng : 0
        latSum += item.yLat ? item.yLat : 0
        if (item.position) {
          orgStation.push(item)
        }
      })
      center = [lngSum / orgStation.length, latSum / orgStation.length]
      commit(
        'mapOptionsSet',
        {
          key: 'center',
          value: center
        },
        {
          root: true
        }
      )
      commit('setResident', { key: 'orgStation', value: orgStation })
      const classifyOrg = classifyArray(project, 'vType')
      var orgLegend = Object.keys(classifyOrg).map((key) => {
        const legend = {
          icon: key === 'simPro' ? '#icon-company-fill' : 'icon-gongsi',
          iconColor: 'red',
          label: key === 'simPro' ? '项目部' : '公司机关',
          value: classifyOrg[key].length,
          unit: '个',
          isShow: true
        }
        return legend
      })
      orgLegend = sortArray(orgLegend, ['label'], [['公司机关', '项目部']])
      commit('setAnalysisData', {
        key: 'legend',
        layer: 'officialCar',
        fields: { orgLegend: orgLegend }
      })
    },
    // 获取工程用车当前实时指标及分项数据
    async getOfficialCarData(
      { state, rootState, rootGetters, commit, dispatch },
      orgUid
    ) {
      await dispatch(
        'officialCar/getOfficialCarList',
        {
          orgUid: orgUid ? orgUid : rootState.user.orgValue
        },
        { root: true }
      )
      var coreIndicators = {}
      var rightAnalysis = {}
      var leftAnalysis = {}
      coreIndicators.noExitCar = {
        icon: '#icon-gongchengjixie',
        label: '在场设备',
        value: rootGetters['officialCar/noExitCar'].length,
        unit: '台'
      }
      coreIndicators.monitor = {
        icon: '#icon-jiankongkongzhiguanlijianguan',
        label: '设备监控',
        value: rootGetters['officialCar/hasMonitor'].length,
        iconColor: '#d81e06',
        unit: '台'
      }
      coreIndicators.onlineCar = {
        icon: '#icon-lianjie',
        label: '监控在线',
        value: rootGetters['officialCar/onlineCar'].length,
        iconColor: '#1afa29',
        unit: '台'
      }
      const classifyOrg = classifyArray(
        rootGetters['officialCar/noExitCar'],
        rootGetters['user/orgType'] === 'com'
          ? 'vprojectName'
          : 'laborCompanyName'
      )
      let warning = []
      let orgClass = Object.keys(classifyOrg).map((key) => {
        const orgCars = classifyOrg[key]
        const orgInfo = state.resident.orgStation
          ? state.resident.orgStation.find((org) => org.orgCode === key)
          : null
        const noExpired = orgCars.filter((item) => item.isExpired !== '未过期')
        const noMaintain = orgCars.filter((item) => item.dayInterval > 120)
        if (noExpired.length) {
          let noExpiredWarn = {
            description:
              key +
              '在场设备中有' +
              noExpired.length +
              '台设备保险未备案或已过期，请督促备案或更新',
            position: orgInfo ? orgInfo.position : null,
            type: '设备保险',
            address: key,
            startTime: daysFormat(new Date()),
            contentType: 'warning'
          }
          warning.push(noExpiredWarn)
        }
        if (noMaintain.length) {
          let noMaintainWarn = {
            description:
              key +
              '在场设备中有' +
              noMaintain.length +
              '台设备超过120天未保养，请督促保养检查',
            position: orgInfo ? orgInfo.position : null,
            type: '设备保养',
            address: key,
            startTime: daysFormat(new Date()),
            contentType: 'warning'
          }
          warning.push(noMaintainWarn)
        }
        return { orgName: key, number: orgCars.length }
      })
      orgClass = sortArray(orgClass, ['number'])
      orgClass.forEach((item, index) => {
        item.ranking = index + 1
        item.icon =
          item.ranking < 4
            ? rootState.dictionarys.rankingIcon[index]
            : rootState.dictionarys.rankingIcon[3]
      })
      let carChange = []
      const types = getDistinct(
        getSameAttribute(rootState.officialCar.officialCarList, 'carUsage')
          .values
      )
      const carClass = {}
      types.forEach((item, index) => {
        const key = 'value' + (index ? index + 1 : '')
        carClass[key] = 0
      })
      carChange.unshift(
        Object.assign({}, { label: monthFormat(new Date()) }, carClass)
      )
      let currentMonth = new Date()
      for (let index = 0; index < 6; index++) {
        currentMonth.setMonth(currentMonth.getMonth() - 1)
        carChange.unshift(
          Object.assign({}, { label: monthFormat(currentMonth) }, carClass)
        )
      }
      carChange = rootState.officialCar.officialCarList.reduce((per, cur) => {
        per.forEach((item) => {
          if (
            new Date(item.label) >= new Date(monthFormat(cur.entryDate)) &&
            (!cur.exit ||
              (cur.exit && new Date(item.label) <= new Date(cur.exitDate)))
          ) {
            if (types.indexOf(cur.carUsage) !== -1) {
              const valueKey =
                'value' +
                (types.indexOf(cur.carUsage)
                  ? types.indexOf(cur.carUsage) + 1
                  : '')
              item[valueKey] = item[valueKey] ? item[valueKey] + 1 : 1
            }
          }
        })
        return per
      }, carChange)
      leftAnalysis.changeTrend = {
        boxModel: 'box1',
        boxTitle: '用车趋势',
        contents: [
          {
            name: 'officialCar',
            id: 'officialCar',
            type: 'chart',
            tab: '设备量',
            chartOption: getBar(carChange, types, ['台'], '#fff')
          }
        ]
      }
      leftAnalysis.orgClass = {
        boxModel: 'box2',
        boxTitle: '设备TOP',
        contents: [
          {
            name: 'orgClass',
            type: 'table',
            tab: '设备数量',
            data: orgClass.length > 4 ? addCopy(orgClass) : orgClass,
            columns: [
              { prop: 'icon', label: '\xa0\xa0', span: 4 },
              { prop: 'ranking', label: '排名', span: 4 },
              { prop: 'orgName', label: '机构', span: 12 },
              { prop: 'number', label: '数量', span: 4 }
            ]
          }
        ]
      }
      leftAnalysis.warning = {
        boxModel: 'box1',
        boxTitle: '预警信息',
        contents: [
          {
            name: 'warning',
            type: 'panel',
            data: addCopy(warning)
          }
        ]
      }
      const classifyType = classifyArray(
        rootGetters['officialCar/noExitCar'],
        'carUsage'
      )
      let carLegend = Object.keys(classifyType).map((key) => {
        const icon = key === '人员通勤' ? '#icon-keche' : '#icon-sashuiche'
        //const iconColor = key === '人员通勤' ? '' : ''
        return {
          label: key,
          value: classifyType[key].length,
          icon: icon,
          iconColor: '',
          unit: '台',
          isShow: true
        }
      })
      const carlists =
        rootGetters['officialCar/onlineCar'].length > 4
          ? rootGetters['officialCar/onlineCar']
          : rootGetters['officialCar/hasMonitor']
      for (let index = 0; index < carlists.length; index++) {
        const item = carlists[index]
        const key = 'car' + (index + 1)
        rightAnalysis[key] = {
          boxModel: 'box1',
          boxTitle:
            '【' +
            item.vprojectName.slice(0, 4) +
            '】' +
            item.carCode +
            '\xa0' +
            item.driverName,
          hasMore: true,
          clickFun: '',
          contents: [
            {
              type: 'descriptions',
              data: [
                {
                  label: '运行状态',
                  value: item.monitoringState,
                  light: true
                },
                {
                  label: '核载人数',
                  numberValue: item.allowPenson,
                  value: '人'
                },
                {
                  label: '最大限速',
                  numberValue: item.allowSpeed,
                  value: 'km/h'
                },
                {
                  label: '保险到期日期',
                  dateValue: item.insuranceExpiryDate
                },
                { label: '最近保养日期', dateValue: item.latestMaintainDate }
              ]
            }
          ]
        }
      }
      rightAnalysis = addCopy(rightAnalysis)
      commit('setAnalysisData', {
        key: 'legend',
        layer: 'officialCar',
        fields: { carLegend: carLegend }
      })
      commit('setAnalysisData', {
        key: 'coreIndicators',
        layer: 'officialCar',
        value: coreIndicators
      })
      commit('setAnalysisData', {
        key: 'leftAnalysis',
        layer: 'officialCar',
        value: leftAnalysis
      })
      commit('setAnalysisData', {
        key: 'rightAnalysis',
        layer: 'officialCar',
        value: rightAnalysis
      })
      commit('setAnalysisData', {
        key: 'hasAnimation',
        layer: 'officialCar',
        value: {
          rightAnalysis: true,
          orgClass: orgClass.length > 4 ? true : false,
          warning: true
        }
      })
    }
  }
}
